"use client";

import { useContext } from "react";
import { ToastContext } from "../provider/toast-provider";

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw Error("useToast must be used within a ToastProvider");
    }
    return context;
};
